import * as joint from '@clientio/rappid';

import { FlowchartConfig } from '../../base/flowchart.config';

export interface CalculatedSize {
  width: number;
  height: number;
}

export class ContainerResizeCalculator {
  static calculateContainerHeightForEmbeds(subActions: joint.dia.Element[]) {
    let totalHeight =
      FlowchartConfig.containerNode.subComponentNode.styles.verticalPaddingBaseBottom +
      FlowchartConfig.containerNode.subComponentNode.styles.verticalPaddingBaseTop;

    subActions.forEach((subAction) => {
      totalHeight += FlowchartConfig.containerNode.subComponentNode.styles.verticalPadding + subAction.attributes.size.height;
    });

    return totalHeight;
  }

  static calculateSizeToGrid(size: CalculatedSize): CalculatedSize {
    let { width, height } = size;
    const gridSize = FlowchartConfig.paper.gridSize * 2;

    if (width % gridSize !== 0) {
      width = Math.ceil(width / gridSize) * gridSize;
    }

    if (height % gridSize !== 0) {
      height = Math.ceil(height / gridSize) * gridSize;
    }

    return { width, height };
  }

  static getMaxWidthOfSubElementWithPadding(subActions: joint.dia.Cell<joint.dia.Cell.Attributes, joint.dia.ModelSetOptions>[]): number {
    let width = 0;
    // get element with max width/
    subActions.forEach((sub) => {
      // Check bbox to find out if any embedded element is outside.
      const bbox = (sub as joint.dia.Element).getBBox({ deep: true });
      if (bbox.width > width) {
        width = this.calculateSizeToGrid({ width: bbox.width, height: bbox.height }).width;
      }
    });
    width += 2 * FlowchartConfig.containerNode.subComponentNode.styles.horizontalPadding;
    return width;
  }
}
